import React from 'react';
import { cn } from './cn.js';

export default function Input({ className, ...props }) {
  return (
    <input
      className={cn(
        'h-12 w-full rounded-2xl border border-ptcm-border bg-white/80 px-4 py-2 text-sm text-ptcm-ink transition-all shadow-[inset_0_1px_0_rgba(255,255,255,0.4)]',
        'placeholder:text-ptcm-muted/70',
        'focus:bg-white focus:outline-none focus:ring-2 focus:ring-ptcm-primary/20 focus:border-ptcm-primary',
        'disabled:cursor-not-allowed disabled:opacity-50',
        'dark:border-gray-800 dark:bg-gray-900/50 dark:text-gray-100 dark:placeholder:text-gray-500',
        'dark:focus:bg-gray-900 dark:focus:border-blue-500 dark:focus:ring-blue-500/20',
        className
      )}
      {...props}
    />
  );
}

